import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARConsignmentSales extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Invoice/InvoiceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARConsignmentSales"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARConsignmentSales"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARConsignmentSales)
